import React from 'react';

export const CustomIcon = () => {
    const clipPathId = 'clip0_17105_15499';

    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            {/* Background SVG */}
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100%"
                height="100%"
                viewBox="0 0 24 24"
                fill="none"
                style={{ position: 'absolute' }}
            >
                <g clipPath={`url(#${clipPathId})`}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12 1.65686L10.0677 0.71231C8.91748 0.150032 7.52857 0.601321 6.92849 1.73231L5.92045 3.63223L3.80202 4.00383C2.54094 4.22504 1.68255 5.40652 1.86186 6.67422L2.16308 8.8038L0.667653 10.3496C-0.222554 11.2698 -0.222548 12.7302 0.667653 13.6504L2.16308 15.1962L1.86186 17.3258C1.68255 18.5935 2.54094 19.775 3.80202 19.9962L5.92045 20.3678L6.92849 22.2677C7.52858 23.3987 8.9175 23.85 10.0677 23.2877L12 22.3432L13.9323 23.2877C15.0825 23.85 16.4714 23.3988 17.0715 22.2677L18.0796 20.3678L20.198 19.9962C21.4591 19.775 22.3175 18.5935 22.1381 17.3258L21.8369 15.1962L23.3323 13.6504C24.2226 12.7302 24.2225 11.2698 23.3323 10.3496L21.8369 8.8038L22.1381 6.67422C22.3174 5.40654 21.4591 4.22504 20.198 4.00383L18.0796 3.63223L17.0715 1.73231C16.4714 0.601312 15.0825 0.150035 13.9323 0.71231L12 1.65686Z"
                        fill="white"
                    />
                </g>
                <defs>
                    <clipPath id={clipPathId}>
                        <path
                            d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z"
                            fill="white"
                        />
                    </clipPath>
                </defs>
            </svg>

            {/* Foreground SVG */}
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="83%"
                height="83%"
                viewBox="0 0 20 20"
                fill="none"
                style={{ position: 'absolute' }}
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.7023 3.52793L13.0902 0.489502L10 2.00007L6.90983 0.489502L5.29772 3.52793L1.90983 4.12222L2.39155 7.52793L0 10.0001L2.39155 12.4722L1.90983 15.8779L5.29772 16.4722L6.90983 19.5106L10 18.0001L13.0902 19.5106L14.7023 16.4722L18.0902 15.8779L17.6085 12.4722L20 10.0001L17.6085 7.52793L18.0902 4.12221L14.7023 3.52793ZM5.00036 10.0255L6.286 8.73987L8.61335 11.0672L13.3168 6.36372L14.6025 7.64936L8.61336 13.6385L5.00036 10.0255Z"
                    fill="#FF5010"
                />
            </svg>
        </div>
    );
};
